<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="UploadBillingListItems"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :resourceTitle="'Billing Plan'|pgettext('UploadBillingListItems|ResourceTitle')"
    :resourceKey="'Upload Items'|pgettext('UploadBillingListItems|ResourceTitle')"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <ItpIcon
        fa="info-circle"
      >
      </ItpIcon>
      <ItpText
        wrap
      >
        {{ 'Upload billing list items from a template file.'|pgettext('UploadBillingListItems') }}
      </ItpText>
    </ItpAlert>
    <hr>
    </hr>
    <DIV
      class="container"
    >
      <ItpForm
        :name="formName"
        :id="formId"
        v-if="loaded"
        @submit="evh_648747096704084_submit($event, {})"
      >
        <ItpFormGroup
          name="file"
          :label="'Input file'|pgettext('UploadBillingListItems')"
          labelFor="file"
          required
        >
          <ItpFormFile
            v-model="file"
            name="file"
            accept=".xlsx"
            required
            :validation="b_3086171180629160_validation"
          >
          </ItpFormFile>
          <DIV
            class="pt-2"
            slot="description"
          >
            <span>
              {{ 'Only XLSX files are allowed.'|pgettext('UploadBillingListItems') }}
            </span>
            <ItpLink
              :text="'Download template'|pgettext('UploadBillingListItems')"
              :href="templateFileURL"
              use-auth
              force-download
              downloadFileName="billing-list-items.xlsx"
            >
            </ItpLink>
          </DIV>
        </ItpFormGroup>
      </ItpForm>
      <ItpAlert
        :show="resultText && !actions.submit.isRunning"
        class="mt-3"
      >
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <span>
          {{ resultText }}
        </span>
      </ItpAlert>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="formId"
      :text="'Upload'|pgettext('UploadBillingListItems')"
      type="submit"
      variant="primary"
      :icon="$config.uploadIcon"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UploadBillingListItems extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  onSumbitCompleted(...args: any[]) {
    const [event] = args;
    const data = event.data.response.data

    if (data == null) {
      this.resultText = this.messages.noRecordsHaveBeenImported;
      return;
    }

    const items = data.result ? data.result.length : 0,

    this.resultText = this.$fn.sprintf(this.messages.recordsHaveBeenImported, { items });
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  file!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  resultText!: any;
  templateFileURL!: any;

  async $$load_templateFileURL() {
    return this.$fn.urlFor('get_billing_list_items_upload_template', { format: 'xlsx' })
  }

  messages!: any;
  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3086171180629160_validation!: any;
  dataMembers = ['file', 'formId', 'formName', 'resultText', 'templateFileURL', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        file: null,
        formId: null,
        formName: "uploadBillingListItems",
        resultText: null,
        templateFileURL: null,
        messages: {
          noRecordsHaveBeenImported: this.$fn.pgettext("UploadBillingListItems", "No records have been imported."),
          recordsHaveBeenImported: this.$fn.pgettext("UploadBillingListItems", "%(items)s items have been imported."),
        }
        ,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_3086171180629160_validation: ["ext:xlsx"
          ,
          "required"
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("UploadBillingListItems|Title", "Upload Billing List Items"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_2262_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_2262, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_648747096704084_script_2268_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_648747096704084_script_2268, alias=undefined
    this.onSumbitCompleted($event)
  }

  async act_648747096704084_script_2268_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_648747096704084_script_2268, alias=undefined
    return {
      value: () => this.act_648747096704084_script_2268_getActionArgs_value($event),
    }
  }

  async act_648747096704084_request_2266_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_648747096704084_request_2266, alias=submit
    return {
      operation: "upload_billing_list_items",
      data: {
        file: this.file
      },
      contentType: "multipart/form-data",
    }
  }

  async evh_648747096704084_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_2270_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_2270, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_2262: actions.CloseModalAction;
    evh_7315092382398562_close_2261: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_2264: actions.CloseComponentAction;
    evh_2248226175642056_close_2263: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_648747096704084_script_2268: actions.ScriptAction;
    evh_648747096704084_success_2267: actions.EventHandlerImpl;
    act_648747096704084_request_2266: actions.RequestAction;
    evh_648747096704084_submit_2265: actions.EventHandlerImpl;
    evh_648747096704084_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_2270: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_2269: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_2262 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_2262_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_2261 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_2262,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_2261],
      }
    );
    const act_2248226175642056_closeComponent_2264 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_2263 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_2264,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_2263],
      }
    );
    const act_648747096704084_script_2268 = new actions.ScriptAction(
      {
        actionArgs: this.act_648747096704084_script_2268_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_2267 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_script_2268,
        event: "success",
        displayName: "script",
      }
    );
    const act_648747096704084_request_2266 = new actions.RequestAction(
      {
        actionArgs: this.act_648747096704084_request_2266_getActionArgs,
        displayName: "submit",
        events: [evh_648747096704084_success_2267],
      }
    );
    const evh_648747096704084_submit_2265 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_request_2266,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_648747096704084_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_648747096704084_submit_2265],
      }
    );
    const act_1419464017721962_closeModal_2270 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_2270_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_2269 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_2270,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_2269],
      }
    );
    return {
      act_7315092382398562_closeModal_2262,
      evh_7315092382398562_close_2261,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_2264,
      evh_2248226175642056_close_2263,
      evh_2248226175642056_close,
      act_648747096704084_script_2268,
      evh_648747096704084_success_2267,
      act_648747096704084_request_2266,
      evh_648747096704084_submit_2265,
      evh_648747096704084_submit,
      act_1419464017721962_closeModal_2270,
      evh_1419464017721962_clickPreventStop_2269,
      evh_1419464017721962_clickPreventStop,
      submit: act_648747096704084_request_2266,
    }
  }
}

Vue.component("UploadBillingListItems", UploadBillingListItems);

</script>